import { List } from './List'
import { Employee } from '@/models/directories/Employee'

export class EmployeePositionParent extends List {
  constructor(obj) {
    super(EmployeePosition, obj)
  }
}

export class EmployeePosition {
  constructor(obj) {
    this.id = (obj && obj?.id) || null
    this.department = obj?.department || null
    this.duty = obj?.duty || null
    this.employee = obj?.employee ? new Employee(obj.employee) : null
    this.personTitle = obj?.personTitle || null
    this.salaryRate = obj?.salaryRate || null
    this.isActual = obj?.isActual || false
  }

  getForAPI() {
    return {
      id: this.id || null,
      department: this.department || null,
      duty: this.duty || false,
      employee: this.employee ? this.employee.getForAPI() : null,
      personTitle: this.personTitle || null,
      salaryRate: this.salaryRate || null,
      isActual: this.isActual || false
    }
  }

  static buildFromAPI(obj) {
    const _this = new EmployeePosition()
    if (obj) {
      _this.id = obj?.id || null
      _this.department = obj?.department || null
      _this.duty = obj?.duty || false
      _this.employee = obj?.employee ? new Employee(obj.employee) : null
      _this.personTitle = obj?.personTitle || null
      _this.salaryRate = obj?.salaryRate || null
      _this.isActual = obj?.isActual || false
    }
    return _this
  }
}
